<template>
  <div>
    <h1 class="common__main-title">Booth List</h1>
    <Search
      class="search"
      @changeConditions="changeConditions"
      ref="search"
    />
    <div class="d-flex mb-3">
      <b-button
        pill
        variant="primary"
        :to="{name:'BoothImport'}"
        class="mr-2"
      >
        Import
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="confirmExportBooths"
      >
        Export
      </b-button>
    </div>

    <Pager v-model="pager" @changePage="changePage" class="mb-2" />
    <Booth :booths="booths"/>
    <Pager v-model="pager" @changePage="changePage" />

    <ConfirmModal ref="confirmModal" isLoadingMode @ok="exportBooths" />
    <SuccessModal ref="sucessModal" />
    <ErrorModal ref="errorModal" />
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/components/parts/Pager.vue';
import Booth from '@/components/parts/booth/Booth.vue';
import Search from '@/components/parts/booth/BoothSearch.vue';
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorModal from '@/components/parts/modal/Error.vue';
import { mapState } from 'vuex';

export default {

  created() {
    this.search(this.conditions, 1);
  },

  data() {
    return {
      isFetchingBooths: false,
      conditions: null,
    };
  },
  components: {
    Search,
    Pager,
    Booth,
    ConfirmModal,
    SuccessModal,
    ErrorModal,
  },
  computed: {
    ...mapState({
      booths: (state) => state.booths.booths,
      pager: (state) => state.booths.pager,
    }),
  },
  methods: {
    search(conditions, page) {
      if (this.isFetchingBooths || this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.isFetchingBooths = true;
      try {
        this.$store.dispatch('fetchBooths', { conditions, page });
        this.isFetchingBooths = false;
      } catch (error) {
        this.openErrorModal(error);
      } finally {
        this.isLoading = false;
      }
    },
    changeConditions(conditioins) {
      this.conditions = conditioins
      this.search(conditioins, 1);
    },
    changePage(page) {
      this.search(this.conditions, page);
    },
    confirmExportBooths() {
      this.$refs.confirmModal.open('Export all booths. Is it OK?');
    },
    exportBooths() {
      this.$store.dispatch('downloadBoothsByCsv')
        .then((response) => {
          const fileName = response.headers['content-disposition'].replace('attachment; filename=', '');
          const csv = response.data;
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
          if (window.navigator.msSaveOrOpenBlob) {
            // IE,Edge対応
            const blob = new Blob([bom, csv], { type: 'text/csv' });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            // chrome, firefox対応
            const url = URL.createObjectURL(new Blob([bom, csv], { type: 'text/csv' }));
            const linkEl = document.createElement('a');
            if (linkEl) {
              linkEl.href = url;
              linkEl.setAttribute('download', fileName);
              document.body.appendChild(linkEl);
              linkEl.click();
              URL.revokeObjectURL(url);
              linkEl.parentNode.removeChild(linkEl);
            }
          }
          this.$refs.confirmModal.close();
          this.$refs.sucessModal.open();
        })
        .catch((error) => {
          this.openErrorModal(error);
        });
    },
    openErrorModal(error) {
      const err = error.response ? error.response.data.message : error.message;
      this.$refs.errorModal.open(err);
    },
  },
};
</script>
